interface IndexKeyParams {
    responseId: number;
}

export const ResponseAnswerKey = {
    index: (params: IndexKeyParams) => ['response-answers', params],
};
